<template>
    <div>
        <div class="button" ref="button">
            <slot name="button" solt="button"></slot>
        </div>
        <div class="search">
            <div class="searchInput" ref="searchInput">
                <div class="searchInfo" v-for="(item,i) in searchData1" :key="i">
                    <el-input v-model="searchForm[item.value]" :placeholder="'请输入'+item.name"  v-if="item.type=='input'" clearable></el-input>
                    <el-input v-model.number="searchForm[item.value]" :placeholder="'请输入'+item.name" type="number" v-if="item.type=='number'" clearable></el-input>
                    <el-date-picker
                        v-model="searchForm[item.value]"
                        type="date"
                        value-format="yyyy-MM-dd"
                        :placeholder="'请选择'+item.name"
                        v-if="item.type=='date'" clearable>
                    </el-date-picker>
                    <el-select v-model="searchForm[item.value]" :placeholder="'请选择'+item.name" v-if="item.type=='select'"  :clearable='item.clearable'>
                        <el-option
                            v-for="(itemSelect,i) in item.options"
                            :key="i"
                            :label="item.props?item.props.label?itemSelect[item.props.label]:itemSelect.label:itemSelect.label"
                            :value="item.props?item.props.value?itemSelect[item.props.value]:itemSelect.value:itemSelect.value">
                        </el-option>
                    </el-select>
                    <el-cascader
                            v-model="searchForm[item.value]"
                            :options="item.options"
                            :props="item.props" :clearable='item.clearable' :placeholder="'请选择'+item.name" v-if="item.type=='cascader'"></el-cascader>
                    <slot :name="item.value" :solt="item.value" v-if="item.type=='slot'"></slot>
                </div>
            </div>
            <div class="searchButton" ref="searchButton">
                <el-button type="primary" @click="search">搜索</el-button>
                <el-button type="success" style="margin-left:10px" v-show="!allSearch" @click="searchDialog=true">高级搜索</el-button>
                <slot name="rightButton" solt="rightButton"></slot>
            </div>
        </div>
        <el-dialog title="高级搜索" :visible.sync="searchDialog" width="750px">
            <el-form>
                <el-row>
                    <el-col :span="item.span" class="item" v-for="(item,i) in searchData" :key="i">
                        <el-form-item :label="item.name" label-position='top'>
                            <el-input v-model="searchForm[item.value]" :placeholder="'请输入'+item.name"  clearable v-if="item.type=='input'"></el-input>
                            <el-input v-model.number="searchForm[item.value]" :placeholder="'请输入'+item.name" clearable type="number" v-if="item.type=='number'"></el-input>
                            <el-date-picker
                                v-model="searchForm[item.value]"
                                type="date"
                                value-format="yyyy-MM-dd"
                                :placeholder="'请选择'+item.name"
                                v-if="item.type=='date'"
                                style="width:100%" clearable>
                            </el-date-picker>
                            <el-select v-model="searchForm[item.value]" :placeholder="'请选择'+item.name" :clearable='item.clearable' v-if="item.type=='select'" style="width:100%">
                                <el-option
                                    v-for="(itemSelect,i) in item.options"
                                    :key="i"
                                    :label="item.props?item.props.label?itemSelect[item.props.label]:itemSelect.label:itemSelect.label"
                                    :value="item.props?item.props.value?itemSelect[item.props.value]:itemSelect.value:itemSelect.value">
                                </el-option>
                            </el-select>
                            <el-cascader
                            v-model="searchForm[item.value]"
                            :options="item.options"
                            :props="item.props" :clearable='item.clearable' :placeholder="'请选择'+item.name" v-if="item.type=='cascader'" style="width:100%"></el-cascader>
                            <slot :name="item.value" :solt="item.value" v-if="item.type=='slot'"></slot>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="searchDialog = false">取 消</el-button>
                <el-button type="primary" @click="searchAll">确 定</el-button>
            </div>
        </el-dialog>
        <div style="clear: both;"></div>
    </div>
</template>
<script>
export default {
    name: "search",
    props:{
        searchData:{
            type: Array,       
            default: ()=>{ return [] }
        },
        searchForm:{
            type:Object,
            default: ()=>{ return {} }
        }
    },
    data() {
        return {
            searchData1:[],
            searchData2:[],
            allSearch:true,
            searchDialog:false,
            searchForm1:JSON.stringify(this.searchForm)
        }
    },
    mounted(){
        this.getWidth()
        window.addEventListener('resize', this.getWidth);
    },
    destroyed() {
        window.removeEventListener('resize', this.getWidth)
    },
    watch:{
        allSearch(){
            this.$nextTick(() => {
                this.getWidth()
            })
        },
        searchData(){
            this.getWidth();
        }
    },
    methods: {
        getWidth(){
            let topWidth=window.innerWidth-240
            let button=this.$refs.button.offsetWidth+20
            let searchButton=this.$refs.searchButton.offsetWidth
            let searchList=topWidth-button-searchButton
            let searchLength=0
            let index=0
            for(var i in this.searchData){
                let inputLength=this.searchData[i].type=='slot'?this.searchData[i].width:210
                searchLength+=inputLength
                if(searchLength<searchList){
                    index++
                }else{
                    break;
                }
            }
            let data=JSON.parse(JSON.stringify(this.searchData))
            this.searchData1=data.splice(0,index)
            this.searchData2=data.splice(-index)
            this.allSearch=this.searchData2.length>0?false:true
        },
        search(){
            this.$emit('getList',true)
        },
        searchAll(){
            this.searchDialog = false;
            this.search()
        },
        clearAll(){
            Object.assign(this.searchForm, JSON.parse(this.searchForm1))
        }
    },
};
</script>
<style lang='scss' scoped>
    .searchInput{
        white-space:nowrap;
        float: left;
        overflow:hidden;
    }
    .button{
        float: left;
    }
    .searchInfo{
        display: inline-block;
    }
    .item{
        padding: 0px 20px;
    }
    /deep/ .el-dialog {
        border-radius:10px ;
        .el-dialog__body{
            max-height: 400px;
            overflow: auto;
            border-top:1px solid #eee;
            border-bottom:1px solid #eee;
            .data{
                display: block;
                margin-top: 40px;
                .lable{
                    display: none;
                }
            }
        }
    }
    .search{
        float: right;
        /deep/ .el-input,.el-select{
            width: 200px;
            margin-right: 10px;
        }
        div{
            display: inline-block;
        }
    }
</style>